import { PermissionDto } from '@/api/generated';

import { RouteEnum } from './Route.model';
import { ROUTES_ALSO_REQUIRED_PERMISSIONS, ROUTES_PERMISSIONS } from './routesPermissions.model';

/**
 * True when the user holds at least one of the required permissions (no requirements means open
 * access) and every one of the also required permissions.
 */
export const hasRequiredPermission = (
  requiredPermissions: PermissionDto[],
  userPermissions: PermissionDto[],
  alsoRequiredPermissions: PermissionDto[] = [],
): boolean =>
  (requiredPermissions.length === 0 ||
    requiredPermissions.some(permission => userPermissions.includes(permission))) &&
  alsoRequiredPermissions.every(permission => userPermissions.includes(permission));

/**
 * True when the route requires no permission, i.e. it is open to every signed-in user.
 */
export const isOpenRoute = (route: RouteEnum): boolean =>
  ROUTES_PERMISSIONS[route].length === 0 && !ROUTES_ALSO_REQUIRED_PERMISSIONS[route]?.length;

export const hasRouteAccess = (route: RouteEnum, userPermissions: PermissionDto[]): boolean =>
  hasRequiredPermission(
    ROUTES_PERMISSIONS[route],
    userPermissions,
    ROUTES_ALSO_REQUIRED_PERMISSIONS[route],
  );
